<template>
  <!-- this is the inertia wrapper shared by ALL pages -->
  <UApp :toaster="{ position: 'top-center' }">
    <Suspense :timeout="0">
      <!-- this div is incredibly important, without it the entire app crashes horribly -->
      <!-- https://github.com/vuejs/core/issues/12920 -->
      <div>
        <slot />
      </div>
    </Suspense>
  </UApp>
</template>
